import React from 'react';
import Title from 'antd/lib/typography/Title';
import {Alert, Button, Divider, message, Popconfirm, Space, Upload} from 'antd';
import {ExcelImportResponse, SubmissionDto, SubmissionApi, SubmissionStatus, UserRole} from '../../scaffold';
import {useBoolean} from 'react-use';
import {useAxios} from '../../Http/AxiosProvider';
import SubmissionPapers from './Papers';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function SubmissionUploadPaper(props: {submission: SubmissionDto; isJudgeVersion: boolean; refresh: () => any}) {
  const [isUploading, _isUploading] = useBoolean(false);
  const axios = useAxios();
  const submitState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionSubmitPost);

  function onSelectFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', String(props.submission.id));
    formData.append('isJudgeVersion', String(props.isJudgeVersion));
    _isUploading(true);
    axios.instance
      .post('Submission/UploadPaper', formData, {
        timeout: 1000 * 60 * 60,
      })
      .then(res => {
        _isUploading(false);
        props.refresh();
      })
      .catch(e => {
        _isUploading(false);
        message.error(e.message);
      });
    return false;
  }

  return (
    <div>
      <Title level={3}>上传电子版论文{props.submission.status?.includes('盲审') && '（盲审版本）'}</Title>
      {props.submission.status?.includes('盲审') && (
        <Alert showIcon className={'m-b-10'} type={'warning'} message={'需要提交盲审格式，文件名及文件内都不能有个人信息'} />
      )}
      {props.submission.status === SubmissionStatus.督导审批需修改 && (
        <Alert className={'m-b-10'} message={'论文存在一定问题，根据督导意见修改（一个月内完成）再次提交督导，重新提交时只需上传最新版本，并附上修改说明'} />
      )}
      {props.submission.status === SubmissionStatus.盲审审批需修改 && (
        <Alert className={'m-b-10'} message={'论文存在一定问题，重新提交时只需上传最新版本，并附上修改说明'} />
      )}
      {props.submission.status === SubmissionStatus.待上传论文 && <Alert className={'m-b-10'} message={'只需上传单个论文 PDF 文件'} />}
      <SubmissionPapers submission={props.submission} isJudgeVersion={props.isJudgeVersion} refresh={props.refresh} readonly={false} />
      <Space className={'m-t-10'}>
        <Upload beforeUpload={onSelectFile} showUploadList={false} accept={'application/pdf'}>
          <Button loading={isUploading}>添加文件</Button>
        </Upload>
        <Popconfirm
          title={'是否要提交审核？'}
          onConfirm={() => {
            submitState
              .request({findParams: {id: props.submission.id || 0}})
              .then(props.refresh)
              .catch(CommonApiErrorHandler);
          }}>
          <Button danger loading={submitState.loading}>
            提交审核
          </Button>
        </Popconfirm>
      </Space>

      <Divider />
    </div>
  );
}
